class NumberUtils {
    static formatMonetary(value) {
        return Number(value).toFixed(2);
    }
}
export default NumberUtils;
